import axios from 'axios'

export const fetchRegions = () =>
  axios
    .get(`/mobiville/api/region`)
    .then((response) => response.data || null)
